(function () {
  const root = document.querySelector('[data-slider-root]');
  if (!root) return;

  const groups = root.querySelectorAll('[data-slider-group]');

  groups.forEach((group) => {
    const wrapper = group.querySelector('[data-track-wrapper]');
    const track   = group.querySelector('[data-track]');
    const prevBtn = group.querySelector('[data-arrow="prev"]');
    const nextBtn = group.querySelector('[data-arrow="next"]');

    if (!wrapper || !track) return;

    // ---- helpers
    const cards = () => Array.from(track.querySelectorAll('.plant-card'));
    const gapPx = getComputedStyle(track).columnGap || getComputedStyle(track).gap || '28px';
    const gap   = parseInt(gapPx, 10) || 28;

    const cardWidth = () => {
      const first = track.querySelector('.plant-card');
      return first ? first.getBoundingClientRect().width : 320;
    };

    const maxScroll = () => wrapper.scrollWidth - wrapper.clientWidth;

    const updateArrows = () => {
      if (!prevBtn || !nextBtn) return;
      const sl = Math.round(wrapper.scrollLeft);
      prevBtn.disabled = sl <= 1;
      nextBtn.disabled = sl >= maxScroll() - 1;
    };

    // ---- arrow click
    const scrollStep = () => cardWidth() + gap;
    const scrollByStep = (dir = 1) => {
      wrapper.scrollBy({ left: dir * scrollStep(), behavior: 'smooth' });
    };

    prevBtn && prevBtn.addEventListener('click', () => scrollByStep(-1));
    nextBtn && nextBtn.addEventListener('click', () => scrollByStep(1));

    // ---- drag scroll (mouse + touch)
    let isDown = false;
    let startX = 0;
    let startLeft = 0;

    const onDown = (clientX) => {
      isDown = true;
      wrapper.classList.add('is-dragging');
      startX = clientX;
      startLeft = wrapper.scrollLeft;
    };
    const onMove = (clientX) => {
      if (!isDown) return;
      const dx = clientX - startX;
      wrapper.scrollLeft = startLeft - dx;
    };
    const onUp = () => {
      if (!isDown) return;
      isDown = false;
      wrapper.classList.remove('is-dragging');
      snapToNearest();
    };

    wrapper.addEventListener('mousedown', (e) => { onDown(e.clientX); });
    window.addEventListener('mousemove', (e) => onMove(e.clientX));
    window.addEventListener('mouseup', onUp);
    // touch
    wrapper.addEventListener('touchstart', (e) => onDown(e.touches[0].clientX), { passive: true });
    wrapper.addEventListener('touchmove',  (e) => onMove(e.touches[0].clientX), { passive: true });
    wrapper.addEventListener('touchend', onUp);

    // ---- auto-center / snap to nearest card after scroll end
    let scrollTimer = null;
    const snapToNearest = () => {
      const cardW = cardWidth() + gap;
      const idx = Math.round(wrapper.scrollLeft / cardW);
      const target = idx * cardW;
      wrapper.scrollTo({ left: target, behavior: 'smooth' });
    };

    wrapper.addEventListener('scroll', () => {
      updateArrows();
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(snapToNearest, 120);
    });

    // init
    updateArrows();
    window.addEventListener('resize', () => { updateArrows(); });

  });
})();